import { Controller } from "@hotwired/stimulus"

const ACTIVE_CLASS = "is-active"
const SCROLL_OFFSET = 20

export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.header = document.querySelector("header")
    this.headerHeight = this.header?.offsetHeight || 0

    if (!this.linkTargets.length) return
    this.sections = this.linkTargets
      .map(link => {
        const id = link.getAttribute("href")?.slice(1)
        return id ? document.getElementById(id) : null
      })
      .filter(Boolean)

    this.rafPending = false
    this.isAutoScrolling = false
    this.autoScrollTargetY = null

    this.onScrollHandler = this.onScroll.bind(this)
    this.onResizeHandler = this.onResize.bind(this)

    window.addEventListener("scroll", this.onScrollHandler, { passive: true })
    window.addEventListener("resize", this.onResizeHandler)

    this.updateActive()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScrollHandler)
    window.removeEventListener("resize", this.onResizeHandler)
  }

  onResize() {
    this.headerHeight = this.header?.offsetHeight || 0
    this.updateActive()
  }

  onScroll() {
    if (this.rafPending) return
    this.rafPending = true
    requestAnimationFrame(() => {
      this.rafPending = false
      if (this.isAutoScrolling && this.autoScrollTargetY != null) {
        const distance = Math.abs(window.scrollY - this.autoScrollTargetY)
        if (distance <= 2) {
          this.isAutoScrolling = false
          this.autoScrollTargetY = null
          this.updateActive()
          return
        }
      }
      this.updateActive()
    })
  }

  updateActive() {
    if (!this.sections || this.sections.length === 0) return

    const headerOffset = this.headerHeight + SCROLL_OFFSET
    let closest = null
    let minDistance = Infinity

    for (const section of this.sections) {
      const rect = section.getBoundingClientRect()
      const distance = Math.abs(rect.top - headerOffset)

      if (distance < minDistance) {
        minDistance = distance
        closest = section
      }
    }

    if (!closest) return

    const id = closest.id
    this.clearActive()
    const activeLink = this.linkTargets.find(link => link.getAttribute("href") === `#${id}`)
    if (activeLink) activeLink.classList.add(ACTIVE_CLASS)
  }

  clearActive() {
    this.linkTargets.forEach(link => link.classList.remove(ACTIVE_CLASS))
  }

  scrollTo(event) {
    event.preventDefault()
    const targetId = event.currentTarget.getAttribute("href")?.slice(1)
    const section = document.getElementById(targetId)
    if (!section) return

    const offset = section.getBoundingClientRect().top + window.scrollY
    const targetY = offset - (this.headerHeight + SCROLL_OFFSET)

    this.isAutoScrolling = true
    this.autoScrollTargetY = Math.round(targetY)

    window.scrollTo({ top: targetY, behavior: "smooth" })

    setTimeout(() => {
      if (this.isAutoScrolling) {
        this.isAutoScrolling = false
        this.autoScrollTargetY = null
        this.updateActive()
      }
    }, 1200)
  }
}
